/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Array)],
  props: {
    items: {type: Array, required: true},
    rows: {type: Number, default: undefined, required: false}
  },
  data() {
    return {
      max_height: 'unset',
      expanded: false
    }
  },
  computed: {
    c_max_height () {
      if (this.expanded) return 'unset'
      return this.max_height
    }
  },
  methods: {
    onResize () {
      if (!this.rows || this.items.length <= this.rows) return
      
      let height = 0
      for (let idx = 0; idx < this.rows; ++idx) {
        const segment = this.$refs.segments[idx].$el
        height += segment.getBoundingClientRect().height
      }

      this.max_height = `${height}px`
    },
    onChange(data){
      if (!data.value && !this.value.includes(data.checkedValue)) {
        this.value.push(data.checkedValue)
      } else if (data.value && this.value.includes(data.checkedValue)) {
        this.value.splice(this.value.indexOf(data.checkedValue), 1)
      }
    }
  }
}
